import { connect } from 'react-redux';

import {
  getIsHotelOnly,
  getIsMobile,
  getIsWhitelabel,
} from 'src/store/view/selectors';
import {
  getDestinationCountry,
  getSearchTitle,
} from '../../selectors/searchParams';
import SearchPage from './SearchPage';
import { isMapViewSelector } from '../../store/map/selectors';
import { firstResultsFetchedSelector } from '../../searchStatus/selectors';
import { isEmptySearchSelector } from '../../store/emptySearch/selectors';
import { getIsSubscribeShown, isFiltersHidden } from '../../selectors/view';
import { isEmptyFiltrationSelector } from '../../store/emptyFiltration/selectors';

const mapStateToProps = (state) => ({
  title: getSearchTitle(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
  mapView: isMapViewSelector(state),
  countryName: getDestinationCountry(state)?.name_ru_form3 || '',
  isWhitelabel: getIsWhitelabel(state),
  isFirstResultsFetched: firstResultsFetchedSelector(state),
  isEmptySearch: isEmptySearchSelector(state),
  isEmptyFiltration: isEmptyFiltrationSelector(state),
  hideFilters: isFiltersHidden(state),
  isSubscribeShown: getIsSubscribeShown(state),
});

export default connect(mapStateToProps)(SearchPage);
